import React from 'react';
import { SaveRegistrationApi } from '@/saveRegistration/SaveRegistrationProvider.tsx';

// @ts-expect-error
export const SaveRegistrationContext = React.createContext<SaveRegistrationApi>({});
